function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./StopPaymentModal.module.scss";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function StopPaymentModal(props) {
  const {
    formattedNumber,
    onSubmit,
    dismissModal
  } = props;
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      reason: ''
    }
  });
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Stop Payment?",
    textAlignCenter: false,
    primaryButtonLabel: "Stop",
    primaryButtonTestid: "submit-stop-payment",
    secondaryButtonLabel: "Back",
    onSecondaryButtonClick: () => dismissModal(),
    onPrimaryButtonClick: handleSubmit(async _ref => {
      let {
        reason
      } = _ref;
      const {
        success
      } = await onSubmit(reason.trim());
      if (success) dismissModal();
    }),
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.root,
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["You're about to stop a payment for invoice ", formattedNumber, "."]
      }), /*#__PURE__*/_jsx(Typography, {
        children: "Please provide a reason for stopping:"
      }), /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "reason",
        rules: requiredValidation(true),
        render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread({
          collapseHelperText: false,
          multiline: true,
          minRows: 6,
          testid: "stop-payment-reason",
          placeholder: "[Example text] Can you remind me what this payment is for? Please call me to discuss..."
        }, connectControllerToTextField(renderProps)))
      })]
    })
  });
}